<template>
    <div>
        <div class="d-flex justify-content-between">
            <h1 class="page-header">
                {{
                    $t('feePredefineItem.pageTitle')
                }}
            </h1>
            <ts-breadcrumb :items="[
                { text: $t('toHomePage'), href: '/' },
                {
                    text: $t(
                        'feePredefineItem.pageTitle'
                    ),
                    active: true
                }
            ]" />
        </div>
        <ts-card>
            <ts-card-wrapper>
                <a-tabs :default-active-key="1" tab-position="top" @change="callback">
                    <a-tab-pane :key="1">
                        <span slot="tab" class="tab-title">
                            <i class="fas fa-file-invoice"></i>
                            <span class="tab-text">{{ $t('feePredefineItem.invoice') }}</span>
                        </span>
                        <pre-define v-if="active_tab == 1" />
                    </a-tab-pane>
                </a-tabs>
            </ts-card-wrapper>
        </ts-card>
    </div>
</template>


<script>
import PreDefine from './components/pre-define'

export default {
    name: 'predefineItem',
    components: {
        PreDefine
    },
    data() {
        return {
            active_tab: 1
        }
    },

    methods: {
        callback(key) {
            this.active_tab = key
        }
    },
}
</script>

<style scoped>
.page-title {
    font-size: 2rem;
    font-weight: 600;
    color: #2c3e50;
    letter-spacing: -0.5px;
}

.tab-title {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    font-size: 1.1rem;
    font-weight: 500;
}

.tab-title i {
    font-size: 1.2rem;
    color: #1890ff;
}

.tab-text {
    font-weight: 500;
    letter-spacing: 0.3px;
}

@media (max-width: 768px) {
    .page-title {
        font-size: 1.5rem;
    }

    .tab-title {
        font-size: 1rem;
    }
}
</style>